// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"296b4a7c","351":"54e3531b","455":"399606b7","499":"67de3ec7","797":"16a6b632","852":"efabf713","859":"4d99b155","936":"0498fdc8","959":"a9be42a6","977":"8c72bf08"}[chunkId] + ".chunk.js";
};